module.exports = __webpack_public_path__ + "fonts/PPRightGrotesk-CompactMedium.4a7dc43.woff";